/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

import { Injectable } from '@angular/core';

/**
 * Service for tracking whether a user is logged in or not.
 */
@Injectable()
export class LoggedOutService {
  isLoggedIn: boolean = null;

  wasPreviouslyLoggedIn: boolean = null;

  /**
   * Similar to watchLoggedInStatusOnRequests but it runs on error responses.
   * @param response
   */
  watchLoggedInStatusOnError(response) {
    if (!response.status.toString().startsWith('5')) {
      this.wasPreviouslyLoggedIn = this.isLoggedIn;
      this.isLoggedIn = response.headers('X-BULB-LOGGED-IN') === 'true';
    }
    return true;
  }

  /**
   * Watch the logged in status on requests.
   * Also updates the lastRequestTime.
   */
  watchLoggedInStatusOnRequests(data, operations, what, url, response) {
    if (url.includes('b/rest/auth/logout')) {
      // Sets fields in a way that prevents the logged out modal opening when intentionally logging out.
      this.wasPreviouslyLoggedIn = false;
      this.isLoggedIn = false;
    } else {
      this.wasPreviouslyLoggedIn = this.isLoggedIn;
      this.isLoggedIn = response.headers('X-BULB-LOGGED-IN') === 'true';
    }
    return data;
  }
}
